"use strict";
/**
 * Base types for a AngularJS component.
 *
 * @packageDocumentation
 * @module Base
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
//#region Util Imports
var lodash_es_1 = require("lodash-es");
/**
 * Base class for AngularJS components.
 * Should be extended by every component class to standardize the way component are implemented.
 */
var IMRBaseComponent = /** @class */ (function () {
    //#endregion
    //#region Ctor
    function IMRBaseComponent(options) {
        this.options = options;
        //#region Members
        /**
         * Options is the only binding every component should have.
         */
        this.bindings = {
            options: '<',
        };
        if (this.options != null) {
            this.template = this.options.template;
            this.bindings = lodash_es_1.assign({}, this.bindings, this.options.bindings);
            var services = this.options.services || [];
            this.controller = tslib_1.__spread(services, [this.options.controller]);
            this.transclude = this.options.isContainer || false;
            if (options.containerSlots != null) {
                this.transclude = options.containerSlots;
            }
            if (options.injectParent != null) {
                this.require = {
                    parentController: "^^" + options.injectParent,
                };
            }
        }
    }
    return IMRBaseComponent;
}());
exports.IMRBaseComponent = IMRBaseComponent;
//# sourceMappingURL=base.component.js.map